var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Default',[_c('div',{staticClass:"wallet"},[_c('FxWallet'),_c('World'),_c('Gateway'),_c('Started'),_c('Partners')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }